// ── Cover image constraints (SEC-BE10 accept — png/jpeg/webp; backend re-validates) ───────────────

/** `accept` for the cover file picker. The backend allow-lists MIME (SEC-BE10) and the consumer wizard
 *  uploads `image/webp`; we accept the three raster formats the backend takes. */
export const COVER_ACCEPT = 'image/png,image/jpeg,image/webp';
/** Client-side size guard (backend is authoritative); keep well under the upload cap. */
export const COVER_MAX_BYTES = 10 * 1024 * 1024; // 10 MB
export const COVER_TOO_LARGE_MESSAGE =
  'That image is over 10 MB. Please choose a smaller cover image.';
export const COVER_WRONG_TYPE_MESSAGE = 'Please choose a PNG, JPG, or WebP image.';

/**
 * How the console frames a cover (EMC-WEB7): 16:9, at most 480px wide, cropped top-weighted, 30% down
 * from the top rather than from the centre, since faces sit high in a photo (a centred strip showed a
 * portrait's hands and not the face). No focal point is stored with a cover yet (photo focus is the
 * deferred EMC-BE13), so the editor, its read-only record and the creation wizard all crop the same way.
 */
export const COVER_FRAME_CLASS =
  'aspect-[16/9] w-full max-w-[480px] rounded-lg object-cover object-[50%_30%]';

/** Fast client check that a picked file is a cover we accept (png/jpeg/webp). Tolerant of a browser that
 *  reports an empty type (fall back to the extension); the backend re-validates the MIME either way. */
export function isAcceptableCover(file: File): boolean {
  if (/^image\/(png|jpe?g|webp)$/i.test(file.type)) return true;
  if (file.type === '') return /\.(png|jpe?g|webp)$/i.test(file.name);
  return false;
}
